<mat-card class="mat-elevation-z8 container-card">
    <app-search-bar [filterFields]="['name']" [filterMap]="{ name: ['name'] }" [filterLabels]="{ name: ['Nome'] }" (filtersChanged)="onFilterChanged($event)">
    </app-search-bar>

    <app-shared-table [dataSource]="dataSourceBiasingPolicy" [displayedColumns]="['name', 'description', 'actions']" [columnLabels]="{ name: 'Nome', description: 'Descrizione' }" [notAllowEdit]="true" [enableRowClick]="true" (rowClick)="goToDetail($event)"
        [length]="totalItems" [pageSize]="pageSize" [pageIndex]="pageIndex" (pageChanged)="onPageChanged($event)" (sortChanged)="onSortChanged($event)" (openModal)="openDialog($event)" [isLoading]="isLoading" [hasError]="hasError">
    </app-shared-table>

    <app-loading [showLoading]="showFullScreenLoading"></app-loading>
</mat-card>